import classNames from "classnames";
import type { FC, KeyboardEvent, ReactNode } from "react";
import { v4 as uuid } from "uuid";
import { useFactory } from "../../helpers/reactHooks";
import { CheckIcon } from "../../icons/icons";
import styles from "./RadioButton.module.scss";

type RadioButtonProps = {
  label: ReactNode;
  checked: boolean;
  errorMessage?: string;
  onChange: () => void;
  className?: string;
};

export const RadioButton: FC<RadioButtonProps> = ({ label, checked, errorMessage, onChange, className }) => {
  const labelId = useFactory(() => uuid());
  const handleCheckBoxEnter = (e: KeyboardEvent<HTMLSpanElement>): void => {
    if (e.key === " ") {
      e.preventDefault();
      e.stopPropagation();
      onChange();
    }
  };

  return (
    <div className={classNames(styles.radioButton, className)}>
      <label
        htmlFor="checkBox"
        className={classNames(styles.container, checked && styles.checked, errorMessage && styles.error)}
      >
        <span
          className={styles.checkmark}
          role="checkbox"
          aria-checked={checked}
          aria-labelledby={labelId}
          tabIndex={0}
          onKeyDown={handleCheckBoxEnter}
        >
          <CheckIcon />
        </span>
        <div id={labelId}>{label}</div>
        <input onChange={onChange} type="checkbox" id="checkBox" checked={checked} tabIndex={-1} />
      </label>
      {!!errorMessage && <span className={styles.errorMessage}>{errorMessage}</span>}
    </div>
  );
};
